"use client";

import { BarChart, Bar, XAxis, YAxis, Tooltip, Legend, ResponsiveContainer, CartesianGrid } from "recharts";

type ChartDataItem = {
    label: string;
    currentLoan: number;
    refiLoan: number;
};

const BarComparisonChart = ({ data }: { data: ChartDataItem[] }) => {
    return (
        <div className="w-full h-64 2xl:w-[874px] 2xl:h-[400px] 2xl:mx-auto">
            <ResponsiveContainer width="100%" height="100%">
                <BarChart barGap={60} data={data} margin={{ top: 20, right: 30, left: 20, bottom: 20 }}>
                    {/* Add horizontal grid lines */}
                    <CartesianGrid vertical={false} />

                    <XAxis dataKey="label" />
                    <YAxis
                        stroke="#666"
                        tickLine={false}
                        axisLine={false}
                        className="text-gray-500 text-[11px]"
                        tickFormatter={(value) => (value >= 1000 ? `${(value / 1000).toFixed(0)}k` : value)}
                    />
                    <Tooltip
                        formatter={(value: number, name: string) => [
                            `$${value.toLocaleString(undefined, {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                            })}`,
                            name === "currentLoan" ? "Current Loan" : "Refi Loan",
                        ]}
                    />
                    <Legend />
                    <Bar dataKey="currentLoan" name="Current Loan" fill="#7cb5eb" barSize={197} />
                    <Bar dataKey="refiLoan" name="Refi Loan" fill="#5c5c61" barSize={197} />
                </BarChart>
            </ResponsiveContainer>
        </div>
    );
};

export default BarComparisonChart;
